class tripDuration {
  constructor() {
    const DURATION_LABELS = [
      "Up to 7 Days",
      "Up to 10 Days",
      "Up to 15 Days",
      "Up to 21 Days",
      "Up to 31 Days",
      "Up to 62 Days",
      "Up to 92 Days",
      "6 Months (Max 92 days/trip)",
      "6 Months (Max 180 days/trip)",
      "9 Months (Max 92 days/trip)",
      "9 Months (Max 180 days/trip)",
      "1 Year (Max 180 days/trip)",
      "2 Years (Max 92 days/trip)",
      "2 Years (Max 180 days/trip)",
      "Long Stay — 1 Year (365 days)",
    ];
    this.items = {
      id: 30001,
      name: "Third party / Fire & Theft",
      type: "text",
      slideimg: "/doctorassistant/dia.jpg",
      options: DURATION_LABELS.map((label, index) => ({
        id: 50000 + index,
        text: label,
        name: label,
        type: "age",
        desc: label,
        inputtype: "button",
        key: "duration",
        value: index,
      })),
      backtostart: false,
      text: [
        `<p>
      Great choice! Now please select the <strong>duration of your trip</strong> from the options below. 
      Your insurance coverage will be valid for the selected travel period.
       </p>`,
      ],
    };
  }

  getAllItems() {
    return this.items;
  }
}

export default tripDuration;
